import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../../../components/unauthorizeHandler";

// export function* handleFetchProjectRevisions({ data }) {
//   console.log("data", data);
//   const { search, id, ...rest } = data;

//   Object.keys(search).forEach((key) => {
//     if (search[key]?.length < 1 || search[key] === null) delete search[key];
//   });

//   try {
//     const response = yield axios.get(
//       `${baseURL}/api/v1/document_control/${id}/revisions`,
//       {
//         params: { ...rest, ...(Object.keys(search).length > 0 && { search }) },
//       }
//     );
//     const { success } = response.data;

//     if (success) {
//       yield put(actions.fetchProjectRevisionsSuccess(response.data.data));
//     } else if (!success) {
//       yield put(actions.fetchProjectRevisionsError());

//       errorHandler(response.data);
//     }
//   } catch (error) {
//     yield put(actions.fetchProjectRevisionsError());
//     console.log(error);
//   }
// }

export function* handleFetchProjectRevisions({ data }) {
  const { uniqueId, projectId, search, onPermissionError, orderBy, orderDirection, page, per_page } = data;
  
  try {
    // Start with base params
    let params = {
      projectId: projectId || null,
      uniqueId: uniqueId || null,
      archived: true,
      orderBy: orderBy || 'projectId',
      orderDirection: orderDirection || 'desc',
      page: page || 1,
      per_page: per_page || 10
    };
    
    // Add search parameters if they exist
    if (search) {
      // Handle area array specially
      if (search.area && Array.isArray(search.area) && search.area.length > 0) {
        params.area = search.area.join(',');
      }
      
      // Handle tracking status arrays
      const trackingStatusFields = [
        'fabricationStatuses',
        'qcReleaseStatuses',
        'corrosionProtectionStatuses',
        'deliveryToSiteStatuses',
        'siteReceiptStatuses'
      ];
      
      trackingStatusFields.forEach(field => {
        if (search[field] && Array.isArray(search[field]) && search[field].length > 0) {
          // Convert array to JSON string for URL parameter
          params[field] = JSON.stringify(search[field]);
        }
      });
      
      // Add other search parameters if they have values
      const searchFields = ['assemblyNo', 'revision', 'uniqueId', 'qty', 'materialType', 'totalGross', 'priorityId', 'perComplete'];
      searchFields.forEach(field => {
        if (search[field]) {
          if (field === 'priorityId' || typeof search[field] === 'number') {
            // Handle numeric values
            params[field] = search[field];
          } else if (typeof search[field] === 'string' && search[field].trim() !== '') {
            // Handle string values
            params[field] = search[field];
          }
        }
      });
    }
    
    // Convert params object to URL query string
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      queryParams.append(key, value);
    });
    
    const response = yield axios.get(`${baseURL}/material-control-registers?${queryParams.toString()}`);
    if (response.status === 200) {
      yield put(actions.fetchProjectRevisionsSuccess(response.data.data));
    } else {
      yield put(actions.fetchProjectRevisionsError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchProjectRevisionsError());
    AntdAlert.error("Something went wrong!");
    if (error.response && error.response.status === 403 && onPermissionError) {
      onPermissionError();
    }
  }
}

// export function* handleFetchActivitiesUtilsData({ data }) {
//   try {
//     const response = yield axios.get(
//       `${baseURL}/api/v1/sales_activities/search_lists`
//     );
//     const { success } = response.data;

//     if (success) {
//       yield put(actions.fetchActivitiesSearchUtilsSuccess(response.data.data));
//     } else if (!success) {
//       errorHandler(response.data);
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

export function* handleCreateProjectRevision({ data }) {
  const fd = new FormData();
  const { parentRecordID, ...rest } = data;
  for (const [key, value] of Object.entries(rest)) {
    if (key === "images" && value !== undefined && value !== null) {
      Array.from(value).forEach((image) => {
        fd.append(`attachments[]`, image);
      });
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    const response = yield axios.post(
      `${baseURL}/api/v1/document_control/${parentRecordID}/revisions`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.createProjectRevisionSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createProjectRevisionError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.createProjectRevisionError());
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleUpdateProjectRevision({ data }) {
  const { id, parentRecordID, ...res } = data;

  const fd = new FormData();
  for (const [key, value] of Object.entries(res)) {
    if (key === "images" && value !== undefined && value !== null) {
      Array.from(value).forEach((image) => {
        const { isLocal } = image;
        if (isLocal) {
          fd.append(`attachments[]`, image);
        }
        // else fd.append("image_ids[]", key);
      });
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    const response = yield axios.patch(
      `${baseURL}/api/v1/document_control/${parentRecordID}/revisions/${id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectRevisionSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateProjectRevisionError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateProjectRevisionError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteProjectRevision({ data }) {
  const { parentRecordID, id, onDeleteSuccess } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v1/document_control/${parentRecordID}/revisions/${id}`
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteProjectRevisionSuccess(response.data.data));
      onDeleteSuccess();
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteProjectRevisionError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectRevisionError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteProjectRevisionAttach({ data }) {
  const { key, recordId, parentRecordID } = data;

  let params = {
    id: key,
  };

  try {
    const response = yield axios.delete(
      `${baseURL}/attachments/${key}`
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(
        actions.deleteProjectRevisionAttachSuccess({
          recordId,
          imgItem: response.data.data,
        })
      );
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteProjectRevisionAttachError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectRevisionAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleAddProjectRevisionAttach({ data }) {
  const { setCurrentUpdateObj } = data;

  const { id, images, parentRecordID } = data.data;

  const fd = new FormData();
  Array.from(images).forEach((image) => {
    const { isLocal } = image;
    if (isLocal) {
      fd.append(`attachments[]`, image);
    }
  });

  try {
    const response = yield axios.patch(
      `${baseURL}/api/v1/document_control/${parentRecordID}/revisions/${id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectRevisionSuccess(response.data.data));
      setCurrentUpdateObj(response.data.data);
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateProjectRevisionError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateProjectRevisionError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
